import { render, staticRenderFns } from "./Theme.vue?vue&type=template&id=d670c1a4&scoped=true&"
import script from "./Theme.vue?vue&type=script&lang=js&"
export * from "./Theme.vue?vue&type=script&lang=js&"
import style0 from "./Theme.vue?vue&type=style&index=0&id=d670c1a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/katonobo/Documents/Web App/dream-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d670c1a4",
  null
  
)

export default component.exports